<mat-expansion-panel class="card shadow-sm m-1 m-sm-3 p-1 p-sm-3" [ngClass]="{'light':light}"
  (afterExpand)="onAfterExpand()"
  (opened)="panelOpenState = true" (closed)="panelOpenState = false">

  <mat-expansion-panel-header>
    <div class="container d-none d-sm-block">
      <div class="row">
        <div class="col-1 app-icon">
          <button mat-icon-button (click)="onClick($event)">
            <mat-icon>add_circle_outline</mat-icon>
          </button>
        </div>
        <div class="col-5">
          <div class="text-left fw-bold">{{predmet.nazov}}</div>
          <div class="text-left fw-bold text-black-50">{{panelOpenState ? predmet.skratkaFull : predmet.skratka}} <span *ngIf="predmet.jazyk">({{predmet.jazyk}})</span></div>
        </div>

        <div class="col-1">
          <div class="znamka" *ngIf="predmet.absolvovany">{{predmet.absolvovany}}</div>
        </div>

        <div class="col-2">
          <div class="text-nowrap text-center">{{predmet.semester}}S</div>
          <div class="text-center">{{predmet.rozsah}}</div>
        </div>
        <div class="col-1 text-center text-nowrap">{{getRocnik(predmet)}}</div>
        <div class="col-1 text-center text-nowrap">{{predmet.kredit}}<span i18n>kreditSkratka</span></div>
        <div class="col-1"></div>
      </div>
    </div>

    <!-- mobile-->
    <div class="d-block d-sm-none">
      <div class="d-flex flex-row">
        <div>
          <button mat-icon-button color="primary" (click)="onClick($event)">
            <mat-icon>add_circle_outline</mat-icon>
          </button>
        </div>
        <div style="line-height: 15px;" class="d-flex flex-column justify-content-center">
          <div class="fw-bold">
            {{predmet.nazov}} ({{panelOpenState ? predmet.skratkaFull : predmet.skratka}})
            <span *ngIf="predmet.absolvovany" class="badge text-bg-primary">{{predmet.absolvovany}}</span>
          </div>
          <div>{{getPredmetInfoMobile(predmet)}}</div>
        </div>
      </div>
    </div>

  </mat-expansion-panel-header>

  <div class="small text-black-50">
    <hr/>
    <mat-spinner [diameter]="25" *ngIf="!detail"></mat-spinner>
    <div *ngIf="detail">

      <div class="row d-none d-sm-table-row">
        <div class="col-lg-1"></div>
        <div class="col-auto">
          <div class="row mb-3">
            <div class="col">
              <div><span class="fw-bold" i18n>Vyučujúci predmetu</span>:</div>
              <div>{{detail.vyucujuci}}</div>
            </div>
          </div>
          <div class="row" *ngIf="detail.podmienujucePredmety">
            <div class="col">
              <span class="fw-bold" i18n>Podmieňujúce predmety</span>: {{detail.podmienujucePredmety}}
            </div>
          </div>
          <div class="row" *ngIf="detail.vylucujucePredmety">
            <div class="col">
              <span class="fw-bold" i18n>Vylučujúce predmety</span>: {{detail.vylucujucePredmety}}</div>
          </div>
          <div class="row" *ngIf="detail.alternujucePredmety">
            <div class="col">
              <span class="fw-bold" i18n>Alternujúce predmety</span>: {{detail.alternujucePredmety}}</div>
          </div>
          <div class="row">
            <div class="col">
              <span class="fw-bold" i18n>Spôsob ukončenia</span>: {{detail.sposobUkoncenia}}</div>
          </div>
          <div class="row" *ngIf="detail.obmedzenie && detail.obmedzenie > 0">
            <div class="col">
              <span class="fw-bold" i18n>Obmedzenia predmetu</span>: {{detail.obmedzenie}}</div>
          </div>
          <div class="row">
            <div class="col">
              <span class="fw-bold" i18n>Počet prihlásených študentov</span>: {{detail.prihlaseni}}</div>
          </div>

          <div *ngIf="predmet.rocnik" class="row">
            <div class="col">
              <span class="fw-bold" i18n>Doporučený ročník</span>: {{getRocnik(predmet)}}
            </div>
          </div>
          <div *ngIf="predmet.semester" class="row">
            <div class="col">
              <span class="fw-bold" i18n>Semester</span>: {{predmet.semester}}S
              <span *ngIf="predmet.semester === 'Z'">(<span i18n>Zimný semester</span>)</span>
              <span *ngIf="predmet.semester === 'L'">(<span i18n>Letný semester</span>)</span>
            </div>
          </div>
          <div *ngIf="predmet.rozsah" class="row">
            <div class="col">
              <span class="fw-bold" i18n>Rozsah výučby</span>: {{predmet.rozsah}}
              <span>({{predmet.rozsahASposobPopis}})</span>
            </div>
          </div>
          <div *ngIf="predmet.kredit" class="row">
            <div class="col">
              <span class="fw-bold" i18n>Počet kreditov</span>: {{predmet.kredit}}
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-3 d-none d-sm-table-row">
        <div class="col mt-3">
          <div class="fw-bold"><span i18n>Stručná osnova predmetu</span>:</div>
          <div *ngFor="let i of detail.popisy">{{i.text}}</div>
        </div>
      </div>

      <!-- mobile-->
      <div class="d-table-row d-sm-none">

          <div><span class="fw-bold" i18n>Vyučujúci predmetu</span>:</div>
          <div>{{detail.vyucujuci}}</div>

          <div class="mt-3" *ngIf="detail.podmienujucePredmety">
            <div><span class="fw-bold" i18n>Podmieňujúce predmety</span>:</div>
            <div>{{detail.podmienujucePredmety}}</div>
          </div>

          <div class="mt-3" *ngIf="detail.vylucujucePredmety">
            <div><span class="fw-bold" i18n>Vylučujúce predmety</span>:</div>
            <div>{{detail.vylucujucePredmety}}</div>
          </div>

          <div class="mt-3" *ngIf="detail.alternujucePredmety">
            <div><span class="fw-bold" i18n>Alternujúce predmety</span>:</div>
            <div>{{detail.alternujucePredmety}}</div>
          </div>

          <div class="mt-3"><span class="fw-bold" i18n>Spôsob ukončenia</span>:</div>
          <div>{{detail.sposobUkoncenia}}</div>

          <div class="mt-3" *ngIf="detail.obmedzenie && detail.obmedzenie > 0">
              <span class="fw-bold" i18n>Obmedzenia predmetu</span>: {{detail.obmedzenie}}
          </div>

          <div class="mt-3">
            <span class="fw-bold" i18n>Počet prihlásených študentov</span>: {{detail.prihlaseni}}
          </div>

          <div *ngIf="predmet.rocnik">
            <span class="fw-bold" i18n>Doporučený ročník</span>: {{getRocnik(predmet)}}
          </div>
          <div *ngIf="predmet.semester">
            <span class="fw-bold" i18n>Semester</span>: {{predmet.semester}}S
            <span *ngIf="predmet.semester === 'Z'">(<span i18n>Zimný semester</span>)</span>
            <span *ngIf="predmet.semester === 'L'">(<span i18n>Letný semester</span>)</span>
          </div>
          <div *ngIf="predmet.rozsah">
            <span class="fw-bold" i18n>Rozsah výučby</span>: {{predmet.rozsah}}
            <span>({{predmet.rozsahASposobPopis}})</span>
          </div>
          <div *ngIf="predmet.kredit">
            <span class="fw-bold" i18n>Počet kreditov</span>: {{predmet.kredit}}
          </div>

          <div class="fw-bold mt-3"><span i18n>Stručná osnova predmetu</span>:</div>
          <div *ngFor="let i of detail.popisy">{{i.text}}</div>

      </div>
    </div>
  </div>
</mat-expansion-panel>
